<template>
  <!-- 详情右侧操作面板 -->
  <div>
    <el-form
      label-width="90px"
      :model="datas"
      size="small"
      class="lef"
      style="margin-top: 20px"
    >
      <!-- <el-form-item label="模块名称：">
        <div class="weiz">
          <div class="ml35">
            <el-input disabled v-model="datas.moduleName"></el-input>
          </div>
        </div>
      </el-form-item> -->
      <!-- 卡片样式选择 -->
      <el-form-item class="lef" label="模块样式：">
        <div class="weiz">
          <div class="weiz-container" style="">
            <!-- 模块样式 -->
            <div
              v-for="(item, index) in moduleStyleList"
              :key="index"
              @click="clickChange(item, index)"
              class="preview-item"
              :class="{
                active: moduleStyleType == item.linkDetail.moduleStyleType,
              }"
            >
              <RightPanelModuleStyle
                :datas="item"
                :imagePath="item.src"
              ></RightPanelModuleStyle>
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
// 引入事件总线
import Bus from "@/utils/bus.js";
export default {
  name: "detailstyle",
  props: {
    datas: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      moduleStyleType: 1,
      // 构造模块样式列表
      moduleStyleList: [
        {
          ...this.datas,
          src: this.$imagePath.image30,
          linkDetail: {
            moduleStyleType: 1, //1  详情1
            moduleName: this.datas.moduleName,
          },
        },
        {
          ...this.datas,
          src: this.$imagePath.image31,
          linkDetail: {
            moduleStyleType: 2, //1  详情1
            moduleName: this.datas.moduleName,
          },
        },
      ],
    };
  },
  created() {
    console.log(
      "详情右侧操作面板===============================",
      this.datas,
      this.$route.query,
      this.moduleStyleList,
    );
    // this.datas.linkDetail.moduleStyleType = 1;
  },
  methods: {
    // 模块样式选择回调
    clickChange(item, index) {
      console.log("点击了", item, index);
      this.moduleStyleType = item.linkDetail.moduleStyleType;
      this.datas.moduleStyleType = item.linkDetail.moduleStyleType;
      Bus.$emit("send-message", this.datas);
      console.log(
        "模块样式点击了",
        item,
        index,
        this.datas,
        this.moduleStyleType,
        this.$store.state.modules.templateData,
      );
    },
  },
};
</script>
